export function extractUSP(components: any[]): any[] {
  const uspComponent = components.find((comp: any) => comp.id === 'usp');
  return uspComponent?.content?.chunks || [];
}
